import { useState } from "react";
import { Row, Col } from "react-bootstrap";
import CalcShell from "../../components/CalcShell";
import CalcField from "../../components/CalcField";
import { formatINR } from "../../utils/format";

const meta = { slug: "inflation", emoji: "📉", title: "Inflation Calculator", desc: "See the real future value of today's money." };

function InflationCalculator() {
  const [amount, setAmount] = useState(100000);
  const [rate, setRate] = useState(6);
  const [years, setYears] = useState(10);

  // Future cost of the same basket (what today's amount will need to be).
  const futureCost = amount * Math.pow(1 + rate / 100, years);
  // Future purchasing power of today's money.
  const realValue = amount / Math.pow(1 + rate / 100, years);

  return (
    <CalcShell
      meta={meta}
      note={
        <span>
          <strong>Why this matters:</strong> Inflation quietly erodes money kept
          idle. To preserve purchasing power, your investments must earn more than
          the inflation rate.
        </span>
      }
    >
      <Row>
        <Col md={6}>
          <CalcField label="Today's amount (₹)" value={amount} onChange={setAmount} min={1000} max={10000000} step={1000} prefix="₹" />
          <CalcField label="Inflation rate (% p.a.)" value={rate} onChange={setRate} min={1} max={15} step={0.5} suffix="%" />
          <CalcField label="Time period (years)" value={years} onChange={setYears} min={1} max={40} suffix="yr" />
        </Col>
        <Col md={6}>
          <div className="fi-calc-result mb-3">
            <div>What costs {formatINR(amount)} today will cost</div>
            <div className="big">{formatINR(futureCost)}</div>
            <small>in {years} years</small>
          </div>
          <div className="fi-stat">
            <div className="num">{formatINR(realValue)}</div>
            <small className="text-muted">
              Future buying power of {formatINR(amount)} kept idle today
            </small>
          </div>
        </Col>
      </Row>
    </CalcShell>
  );
}

export default InflationCalculator;
